import { ButtonPrimary, ButtonSecondary } from 'components/Button'
import { LoadingRows as BaseLoadingRows } from 'components/Loader/styled'
import { RowBetween } from 'components/Row'
import { AlertTriangle } from 'react-feather'
import { Text } from 'rebass'
import styled, { css } from 'styled-components'

export const PageWrapper = styled.div`
  max-width: 1140px;
  margin: 0px auto;

  width: 100%;
  /* background: ${({ theme }) => theme.cardPrimary}; */
  /* border: 1px solid ${({ theme }) => theme.cardBorderPrimary}; */
  border-radius: 8px;

  padding: 40px 0;
  gap: 16px;

  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 32px 0;
  `};
`

export const FlexRow = styled.div`
  display: flex;
`

export const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
`

export const RefreshButton = styled(ButtonSecondary)<{ isRefreshing?: boolean }>`
  width: 36px;
  height: 36px;
  border-radius: 4px !important;
  background-color: rgba(71, 85, 105, 0.5) !important;
  border: none !important;

  &:hover {
    background-color: rgba(71, 85, 105, 0.7) !important;
  }

  svg {
    width: 16px;
    height: 16px;
    color: ${({ theme }) => theme.textPrimary} !important;
    ${({ isRefreshing }) =>
      isRefreshing &&
      `
    animation: spin 1s linear infinite;
  `}
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`

export const Header = styled(FlexRow)`
  justify-content: space-between;
  background: ${({ theme }) => theme.cardPrimary};
  border: 1px solid ${({ theme }) => theme.cardBorderPrimary};
  border-radius: 8px;
  padding: 24px;
  gap: 16px;
  width: 100%;
  flex-wrap: wrap;
  height: 138px;
`

export const HeaderTitleFlex = styled(FlexCol)`
  gap: 8px;
`

export const HeaderBoxFlex = styled(FlexRow)`
  gap: 16px;
  // height: 100%;
`

export const HeaderBox = styled(FlexCol)`
  padding: 16px;
  gap: 8px;
  height: 100%;
  width: 200px;
  background: ${({ theme }) => theme.cardSecondary};
  border: 1px solid ${({ theme }) => theme.cardBorderPrimary};
  border-radius: 8px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 120px;
  `};
`

export const HeaderBoxDesktop = styled(HeaderBox)`
  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: none;
  `};
`

export const FilterFlex = styled(FlexRow)`
  width: 100%;
  max-width: 97vw;
  gap: 16px;
  justify-content: space-between;
  min-height: 36px;
  padding: 0 8px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    gap: 16px;
    flex-wrap: wrap;
  `}

  ${({ theme }) => theme.mediaWidth.upToSmall`
    gap: 16px;
  `}
`

export const SearchWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 250px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 220px;
  `}

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 220px;
    order: 2;
  `}
`

export const Option = styled.div<{ active: boolean }>`
  display: inline-block;
  width: contain;
  cursor: pointer;
  padding: 4px 8px;
  text-align: center;
  gap: 4px;
  border-radius: 3px;
  white-space: nowrap;
  flex-shrink: 0;
  background: ${({ active, theme }) => (active ? theme.cardPrimary : 'transparent')};
  color: ${({ active, theme }) => (active ? theme.textPrimary : theme.textSecondary)};

  /* border: 1px solid ${({ theme }) => theme.backgroundOutline}; */

  pointer-events: ${({ active }) => active && 'none'}};
`

export const Switch = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  padding: 6px 4px;
  border-radius: 6px;
  height: 36px;
  background: ${({ theme }) => theme.cardSecondary};
  border: 1px solid ${({ theme }) => theme.cardBorderPrimary};
  display: flex;
  align-items: center;
  justify-content; center;

  /* Add these properties for proper scrolling */
  overflow-x: auto;
  overflow-y: hidden;
  touch-action: pan-x;
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Edge */
  }

  /* Ensure inner content doesn't wrap */
  white-space: nowrap;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: fit-content;
    order: 1;

  `}
`

export const SelectWrapper = styled.div`
  display: flex;
  padding: 6px 6px;
  align-items: center;
  /* gap: 10px; */
  border-radius: 4px;

  background: ${({ theme }) => theme.cardPrimary};
  border: 1px solid ${({ theme }) => theme.cardBorderPrimary};
  height: 100%;
`

export const OrientationButton = styled.div<{ active: boolean }>`
  display: flex;
  justify-content: center;
  text-align: center;
  border-radius: 3px;
  background: ${({ active, theme }) => (active ? theme.cardSecondary : 'transparent')};
  padding: 4px;
  align-items: center;
  gap: 10px;
  pointer-events: ${({ active }) => active && 'none'};
`

export const ChangeOrientationButtonFlex = styled.div`
  cursor: pointer;

  display: flex;

  padding: 4px;
  align-items: center;
  border-radius: 6px;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.09);
  background: ${({ theme }) => theme.cardPrimary};
  height: 100%;
`

export const Wrapper = styled.div`
  position: relative;
  /* padding: 20px; */
`

export const ClickableText = styled(Text)`
  :hover {
    cursor: pointer;
  }
  color: ${({ theme }) => theme.deprecated_primary1};
`
export const MaxButton = styled.button<{ width: string }>`
  padding: 0.5rem 1rem;
  background-color: ${({ theme }) => theme.deprecated_primary5};
  border: 1px solid ${({ theme }) => theme.deprecated_primary5};
  border-radius: 0.5rem;
  font-size: 1rem;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    padding: 0.25rem 0.5rem;
  `};
  font-weight: 500;
  cursor: pointer;
  margin: 0.25rem;
  overflow: hidden;
  color: ${({ theme }) => theme.deprecated_primary1};
  :hover {
    border: 1px solid ${({ theme }) => theme.deprecated_primary1};
  }
  :focus {
    border: 1px solid ${({ theme }) => theme.deprecated_primary1};
    outline: none;
  }
  width: ${({ width }) => width};
`

export const Dots = styled.span`
  &::after {
    display: inline-block;
    animation: ellipsis 1.25s infinite;
    content: '.';
    width: 1em;
    text-align: left;
  }
  @keyframes ellipsis {
    0% {
      content: '.';
    }
    33% {
      content: '..';
    }
    66% {
      content: '...';
    }
  }
`

export const LoadingRows = styled(BaseLoadingRows)`
  min-width: 75%;
  max-width: 1140px;
  grid-column-gap: 0.5em;
  grid-row-gap: 0.8em;
  grid-template-columns: repeat(3, 1fr);

  & > div:nth-child(4n + 1) {
    grid-column: 1 / 3;
  }
  & > div:nth-child(4n) {
    grid-column: 3 / 4;
    margin-bottom: 2em;
  }
`

// ############### Liquidity Page Styles ###############
const ResponsiveButtonPrimary = styled(ButtonPrimary)<{ disableExpand?: boolean }>`
  border-radius: 6px;
  padding: 6px 16px;
  border: none;
  width: fit-content;
  ${({ disableExpand, theme }) =>
    !disableExpand &&
    theme.mediaWidth.upToSmall`
    flex: 1 1 auto;
    width: 100%;
  `};

  ${({ disableExpand, theme }) => theme.mediaWidth.upToSmall`
    font-size: 12px;
  `};
`
export const ErrorContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  padding: 48px 0;
  max-width: 300px;
  /* min-height: 25vh; */
`

export const TitleRow = styled(RowBetween)`
  color: ${({ theme }) => theme.deprecated_text2};
  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;
  `};
`

export const MainContentWrapper = styled.main`
  background-color: ${({ theme }) => theme.cardSecondary};
  padding: 16px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.cardBorderPrimary};
  display: flex;
  flex-direction: column;
`

export const IconStyle = css`
  width: 40px;
  height: 40px;
  margin-bottom: 0.5rem;
`

export const NetworkIcon = styled(AlertTriangle)`
  ${IconStyle}
`
